export function validateSignUpForm($form) {
  let isValid = true;
  const $fName = $form.find("input[name='FNAME']");
  if ($fName.val())
  {
    $fName.closest(".mc-field-group").removeClass("error-field-required");
  }
  else
  {
    isValid = false;
    $fName.closest(".mc-field-group").addClass("error-field-required");
  }

  const $lName = $form.find("input[name='LNAME']");
  if ($lName.val())
  {
    $lName.closest(".mc-field-group").removeClass("error-field-required");
  }
  else
  {
    isValid = false;
    $lName.closest(".mc-field-group").addClass("error-field-required");
  }

  const $email = $form.find("input[name='EMAIL']");
  const $company = $form.find('.form-field--company');
  $company.removeClass("error-field-required");
  if ($email.val())
  {
    $email.closest(".mc-field-group").removeClass("error-field-required");
    if (validateEmail($email.val()))
    {
      $email.closest(".mc-field-group").removeClass("error-field-invalid");

    }
    else
    {
      isValid = false;
      $email.closest(".mc-field-group").addClass("error-field-invalid");
      $company.addClass("error-field-required");
    }
  }
  else
  {
    isValid = false;
    $email.closest(".mc-field-group").addClass("error-field-required");
    $company.addClass("error-field-required");
  }

  const $language = $form.find("input[name='LANG']");
  if ($language.val())
  {
    $language.closest(".mc-field-group").removeClass("error-field-required");
  }
  else
  {
    isValid = false;
    $language.closest(".mc-field-group").addClass("error-field-required");
  }

  /*const $newsLetters = $form.find('#newsletterList input[type=checkbox]');
  const newsLetters = $newsLetters.toArray();
  const noOfNewsLetters = newsLetters.length;
  let newsLetterSelected = noOfNewsLetters < 2;
  if (noOfNewsLetters > 1)
  {
    for (let i = 0; i < noOfNewsLetters; i++)
    {
      const checkbox = newsLetters[i];
      if (checkbox.checked)
      {
        newsLetterSelected = true;
        break;
      }
    }
  }

  if (newsLetterSelected)
  {
    $newsLetters.closest(".mc-field-group").removeClass("error-field-required");
  }
  else
  {
    isValid = false;
    $newsLetters.closest(".mc-field-group").addClass("error-field-required");
  }*/

  let $gdpr = $form.find("input#gdpr_id");
  if($gdpr.length == 0){
     $gdpr = $form.find("input#gdpr_id_3");
  }
  if ($gdpr.is(':checked'))
  {
    $gdpr.closest(".mc-field-group").removeClass("error-field-required");
  }
  else
  {
    isValid = false;
    $gdpr.closest(".mc-field-group").addClass("error-field-required");
  }

  return isValid;
}

export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
